import { Phone, CalendarCheck } from "lucide-react";
import { URGENCY, CONTACT } from "../data/content";

export const StickyBottomBar = ({ onBookVisit }) => {
  const items = [...URGENCY.tickers, ...URGENCY.tickers];

  return (
    <div
      data-testid="sticky-bottom-bar"
      className="fixed bottom-0 left-0 right-0 z-40"
    >
      {/* Row 1 — scrolling urgency marquee (glass dark) */}
      <div className="relative overflow-hidden bg-[#142415]/85 backdrop-blur-xl border-t border-white/10">
        <div className="flex whitespace-nowrap animate-[ticker_26s_linear_infinite] py-2.5">
          {items.map((t, i) => (
            <span
              key={i}
              className="mx-6 text-[13px] sm:text-sm font-medium text-[#EAE0D5] flex items-center"
            >
              {t}
              <span className="ml-6 h-1.5 w-1.5 rounded-full bg-[#C15B3D]" />
            </span>
          ))}
        </div>
      </div>

      {/* Row 2 — CTA actions */}
      <div className="bg-[#2C5F2D] border-t border-[#1E4320]">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2.5 flex items-center gap-3">
          <a
            data-testid="sticky-call-button"
            href={`tel:+91${CONTACT.phone}`}
            className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/5 px-5 py-3 text-sm font-semibold text-white transition-all hover:bg-white/15"
          >
            <Phone className="h-4 w-4" />
            <span className="hidden xs:inline sm:inline">Call Now</span>
          </a>
          <button
            data-testid="sticky-book-visit-button"
            onClick={onBookVisit}
            className="flex-[2] sm:flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#C15B3D] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-black/20 transition-all hover:bg-[#A84C31] hover:-translate-y-0.5"
          >
            <CalendarCheck className="h-4 w-4" />
            Book a Site Visit
          </button>
        </div>
      </div>
    </div>
  );
};
